// extracted by mini-css-extract-plugin
export default {"dot":"styles_dot__H8SDL"};